import React, { createContext, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useReservation } from './useReservation'
import { useCaptureUddsCheckoutRecovery } from './checkoutRecovery/useCaptureUddsCheckoutRecovery'

const ReservationContext = createContext(null)

export const ReservationStateProvider = ({ value, children }) => {
    const { t, i18n } = useTranslation()

    return (
        <ReservationContext.Provider value={{ ...value, t, i18n }}>
            {children}
        </ReservationContext.Provider>
    )
}

export const ReservationProvider = ({ children }) => {
    const reservation = useReservation()
    const checkoutRecoveryCapture =
        useCaptureUddsCheckoutRecovery(reservation)

    return (
        <ReservationStateProvider
            value={{
                ...reservation,
                checkoutRecoveryCapture,
            }}
        >
            {children}
        </ReservationStateProvider>
    )
}

export const useReservationContext = () => {
    const context = useContext(ReservationContext)

    if (!context) {
        throw new Error(
            'useReservationContext must be used within a reservation state provider',
        )
    }

    return context
}
